import { controls } from "../../controls";

const rp616 = {
  label: "Bank Loan Overdue Information",
  pageLabel: "Bank Loan Overdue Information",
  starting: true,
  url: "rp616",
  //formActions: { edit: { allow: true }, delete: { allow: true }, audit: { allow: true } },
  pageType: "history", //pageType: "report",
  // formTabs: {
  //   allTabs: [
  //     {
  //       label: "Basic Info",
  //       uid: "create",
  //       style: { fontFamily: "verdana" }
  //     }
  //   ]
  // },
  filter: [

    ...controls.displayText({ tab: "filter", label: "As on Date", star: true, width: "col-sm-2 " }),
    ...controls.magicDate({ tab: "filter", isRequired: true, name: "as_on_date", width: "col-sm-2", onLeave: [{ action: '1 years ago', target: "oneyeardate" }, { action: '2 years ago', target: "twoyeardate" }, { action: '3 years ago', target: "threeyeardate" }, { action: '4 years ago', target: "fouryeardate" }, { action: '5 years ago', target: "fiveyeardate" }, { action: '6 years ago', target: "sixyeardate" },] }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-3 " }),

    ...controls.displayText({ tab: "filter", label: "# Records", width: "col-sm-1" }),
    ...controls.perPage({ tab: 'filter' }),
  ],

  form: [],

  history: {
    perPage: 10,
    reportHeader: "Bank Loan Overdue Information",
    pdfProps: { pageSize: "A4", pageOrientation: "landscape" },
    
    displayColumns: [
      {
        Header: "Account No.",
        accessor: "acctcode",
        width: 150
        
      },
      {
        Header: "Name of Society",
        accessor: "descn",
        width: 100
         
      },
      {
        accessor: "expdate",
        Header: "A/C Expiry Date",
        type:"date"
        
      },
      {
        Header: "OD Date",
        accessor: "oddate",
        type:"date"
        
      },
      {
        Header: "Overdues",
        columns: [
          {
            Header: "Within 1 Year",
            accessor: "inyear",
            
            type: "currency"
          },
          {
            Header: "Above 1 year but below 2 years",
            accessor: "onetotwoyear",
            
            type: "currency"
          },
          {
            Header: "Above 2 year but below 3 years",
            accessor: "twotothreeyear",
            
            type: "currency"
          },
          {
            Header: "Above 3 year but below 4 years",
            accessor: "threetofouryear",
            
            type: "currency"
          },
          {
            Header: "Above 4 year but below 5 years",
            accessor: "fourtofiveyear",
            
            type: "currency"
          },
          {
            Header: "Above 5 year but below 6 years",
            accessor: "fivetosixyear",
            
            type: "currency"
          },
          {
            Header: "Overdues Above 6 years",
            accessor: "abovesixyear",
            
            type: "currency"
          },
          {
            Header: "Overdues Total",
            accessor: "Overdues_Total",
            formula: [{ f: 'simpleArithmatic', calcType: 'sum', inputs: [{ source: 'row', field: 'inyear' }, { source: 'row', field: 'onetotwoyear' },
           { source: 'row', field: 'twotothreeyear' },{ source: 'row', field: 'threetofouryear' },{ source: 'row', field: 'fourtofiveyear' },
           { source: 'row', field: 'fivetosixyear'}, { source: 'row', field: 'abovesixyear'}    
            ], resultVar: 'total' }],
            
            type: "currency"
          }
        ]
      }
    ]
  }
};

export default rp616;